import axios from 'axios';
import i18n from '@/i18n';
import { dayjs } from '@/plugins/dayjs';

export default {
  baseURL: process.env.BASE_URL + 'api/reports',

  getCheckReport(surveyInstanceId, options, cancelToken) {
    return axios.get('get-check-report',
      {
        baseURL: this.baseURL,
        params: {
          'survey-instance-id': surveyInstanceId,
          'localization-id': (options && options.localizationId) ? options.localizationId : null,
          'target-group': (options && options.targetGroup) ? options.targetGroup : null,
        },
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      });
  },

  getCheckReports(surveyInstanceIds, options, cancelToken) {
    return axios.post('get-check-reports', {
        'SurveyInstanceIds': surveyInstanceIds,
        'UseSurveyDefaultLocalization': (options && options.useSurveyDefaultLocalization !== undefined) ? options.useSurveyDefaultLocalization : true,
        'LocalizationId': (options && options.localizationId) ? options.localizationId : i18n.global.locale,
      },
      {
        baseURL: this.baseURL,
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      });
  },

  getRawData(filter, options, cancelToken) {
    return axios.post('get-raw-data',
      {
        'survey-id': (filter && _.size(filter.surveyIds) > 0) ? filter.surveyIds[0] : null,
        'is-quality-assurance': options ? options.isQualityAssurance : null,
        'wave-ids': (filter && _.size(filter.waveIds) > 0) ? filter.waveIds.join() : null,
        'scenario-ids': (filter && _.size(filter.scenarioIds) > 0) ? filter.scenarioIds.join() : null,
        "date-from": filter?.dateFrom ? dayjs(filter?.dateFrom).format('YYYY-MM-DD') : null,
        "date-to": filter?.dateTo ? dayjs(filter?.dateTo).format('YYYY-MM-DD') : null,
        'property-ids': (filter && _.size(filter.propertyIds) > 0) ? filter.propertyIds.join('|') : null,
        'target-group': filter ? filter.targetGroup : null,
        'survey-instance-status-minimum': filter ? filter.surveyInstanceStatusMinimum : null,
        'survey-instance-status-maximum': filter ? filter.surveyInstanceStatusMaximum : null,
        'kpi-ids': (filter && _.size(filter.kpiIds) > 0) ? filter.kpiIds.join() : null,
        'include-kpi-points': options ? options.includeKpiPoints : null,
        'include-kpi-percentages':  options ? options.includeKpiPercentages : null,
        'include-cluster-points': options ? options.includeClusterPoints : null,
        'include-cluster-percentages':  options ? options.includeClusterPercentages : null,
        'include-location-info': options ? options.includeLocationInfo : null,
        'include-properties': options ? options.includeProperties : null,
        'include-questions-without-answers': options ? options.includeQuestionsWithoutAnswers : null,
        'include-testchecks': filter ? filter.includeTestchecks : null,
        'include-overall-points': options ? options.includeOverallPoints : null,
        'localization-id': (options && options.localizationId) ? options.localizationId : i18n.global.locale
      },
      {
        baseURL: this.baseURL,
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      });
  },
  getRawDataTankUndRast(filter, options, cancelToken) {
    return axios.post('get-raw-data-TankUndRast',
      {
        'survey-id': (filter && _.size(filter.surveyIds) > 0) ? filter.surveyIds[0] : null,
        'is-quality-assurance': options ? options.isQualityAssurance : null,
        'wave-ids': (filter && _.size(filter.waveIds) > 0) ? filter.waveIds.join() : null,
        'scenario-ids': (filter && _.size(filter.scenarioIds) > 0) ? filter.scenarioIds.join() : null,
        "date-from": filter?.dateFrom ? dayjs(filter?.dateFrom).format('YYYY-MM-DD') : null,
        "date-to": filter?.dateTo ? dayjs(filter?.dateTo).format('YYYY-MM-DD') : null,
        'property-ids': (filter && _.size(filter.propertyIds) > 0) ? filter.propertyIds.join('|') : null,
        'target-group': filter ? filter.targetGroup : null,
        'survey-instance-status-minimum': filter ? filter.surveyInstanceStatusMinimum : null,
        'survey-instance-status-maximum': filter ? filter.surveyInstanceStatusMaximum : null,
        'kpi-ids': (filter && _.size(filter.kpiIds) > 0) ? filter.kpiIds.join() : null,
        'include-kpi-points': options ? options.includeKpiPoints : null,
        'include-kpi-percentages':  options ? options.includeKpiPercentages : null,
        'include-cluster-points': options ? options.includeClusterPoints : null,
        'include-cluster-percentages':  options ? options.includeClusterPercentages : null,
        'include-location-info': options ? options.includeLocationInfo : null,
        'include-properties': options ? options.includeProperties : null,
        'include-questions-without-answers': options ? options.includeQuestionsWithoutAnswers : null,
        'include-testchecks': filter ? filter.includeTestchecks : null,
        'include-overall-points': options ? options.includeOverallPoints : null,
        'localization-id': (options && options.localizationId) ? options.localizationId : i18n.global.locale
      },
      {
        baseURL: this.baseURL,
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      });
  },

  getRawDataIdPoints(filter, options, cancelToken) {
    return axios.post('get-raw-data-id-points',
      {
        'survey-id': (filter && _.size(filter.surveyIds) > 0) ? filter.surveyIds[0] : null,
        'wave-ids': (filter && _.size(filter.waveIds) > 0) ? filter.waveIds.join() : null,
        'scenario-ids': (filter && _.size(filter.scenarioIds) > 0) ? filter.scenarioIds.join() : null,
        "date-from": filter?.dateFrom ? dayjs(filter?.dateFrom).format('YYYY-MM-DD') : null,
        "date-to": filter?.dateTo ? dayjs(filter?.dateTo).format('YYYY-MM-DD') : null,
        'property-ids': (filter && _.size(filter.propertyIds) > 0) ? filter.propertyIds.join('|') : null,
        'survey-instance-status-minimum': filter ? filter.surveyInstanceStatusMinimum : null,
        'survey-instance-status-maximum': filter ? filter.surveyInstanceStatusMaximum : null,
        'include-check-info': options ? options.includeCheckInfo : null,
        'include-location-info': options ? options.includeLocationInfo : null,
        'include-testchecks': filter ? filter.includeTestchecks : null,
        'localization-id': (options && options.localizationId) ? options.localizationId : i18n.global.locale
      }, {
        baseURL: this.baseURL,
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      });
  },

  getRawDataNew(filter, options, cancelToken) {
    return axios.post('get-raw-data-new', {
        'IsQualityAssurance': options ? options.isQualityAssurance : undefined,
        'SurveyIds': (filter && _.size(filter.surveyIds) > 0) ? filter.surveyIds.join() : undefined,
        'WaveIds': (filter && _.size(filter.waveIds) > 0) ? filter.waveIds.join() : undefined,
        'ScenarioIds': (filter && _.size(filter.scenarioIds) > 0) ? filter.scenarioIds.join() : undefined,
        'DatePeriods': (filter && _.size(filter.datePeriods) > 0) ? filter.datePeriods.join() : null,
        'ClientLocationIds': (filter && _.size(filter.clientLocationIds) > 0) ? filter.clientLocationIds.join() : undefined,
        'CustomPropertyValueIds': (filter && _.size(filter.customPropertyValueIds) > 0) ? filter.customPropertyValueIds.join('|') : undefined,
        'CustomPropertyUseLogicalAnd': filter ? filter.customPropertyUseLogicalAnd : undefined,
        'TargetGroup': filter ? filter.targetGroup : undefined,
        'SurveyInstanceStatusIdMinimum': filter ? filter.surveyInstanceStatusIdMinimum : undefined,
        'SurveyInstanceStatusIdMaximum': filter ? filter.surveyInstanceStatusIdMaximum : undefined,
        'IncludeSectionGridPoints': options ? options.includeSectionGridPoints : undefined,
        'IncludeSectionGridPercentages':  options ? options.includeSectionGridPercentages : undefined,
        'IncludeOnlyCluster':  options ? options.includeOnlyCluster : undefined,
        'IncludeKpiPoints':  options ? options.includeKpiPoints : undefined,
        'IncludeKpiPercentages':  options ? options.includeKpiPercentages : undefined,
        'IncludeKpiQuestions':  options ? options.includeKpiQuestions : undefined,
        'KpiIds': (filter && _.size(filter.kpiIds) > 0) ? filter.kpiIds.join() : undefined,
        'IncludeLocationInfo': options ? options.includeLocationInfo : undefined,
        'IncludeCustomProperties':  options ? options.includeCustomProperties : undefined,
        'IncludeQuestionsWithoutAnswers':  options ? options.includeQuestionsWithoutAnswers : undefined,
        'IncludeTestchecks': filter ? filter.includeTestchecks : undefined,
        'IncludeOverallScore': options ? options.includeOverallScore : undefined,
        'IncludeOverallPoints': options ? options.includeOverallPoints : undefined,
        'SortOrder': options ? options.sortOrder : undefined,
        'LocalizationId': (options && options.localizationId) ? options.localizationId : i18n.global.locale,
      },
      {
        baseURL: this.baseURL,
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      });
  },

  getRawDataScore(filter, options, cancelToken) {
    return axios.post('get-raw-data-score', {
        'SurveyIds': (filter && _.size(filter.surveyIds) > 0) ? filter.surveyIds.join() : undefined,
        'WaveIds': (filter && _.size(filter.waveIds) > 0) ? filter.waveIds.join() : undefined,
        'ScenarioIds': (filter && _.size(filter.scenarioIds) > 0) ? filter.scenarioIds.join() : undefined,
        'DatePeriods': (filter && _.size(filter.datePeriods) > 0) ? filter.datePeriods.join() : null,
        'ClientLocationIds': (filter && _.size(filter.clientLocationIds) > 0) ? filter.clientLocationIds.join() : undefined,
        'CustomPropertyValueIds': (filter && _.size(filter.customPropertyValueIds) > 0) ? filter.customPropertyValueIds.join('|') : undefined,
        'CustomPropertyUseLogicalAnd': filter ? filter.customPropertyUseLogicalAnd : undefined,
        'TargetGroup': filter ? filter.targetGroup : undefined,
        'SurveyInstanceStatusIdMinimum': filter ? filter.surveyInstanceStatusIdMinimum : undefined,
        'SurveyInstanceStatusIdMaximum': filter ? filter.surveyInstanceStatusIdMaximum : undefined,
        'IncludeQuestionPoints': options ? options.includeQuestionPoints : undefined,
        'IncludeAnswers': options ? options.includeAnswers : undefined,
        'IncludeSectionGridPoints': options ? options.includeSectionGridPoints : undefined,
        'IncludeSectionGridPercentages':  options ? options.includeSectionGridPercentages : undefined,
        'IncludeOnlyCluster':  options ? options.includeOnlyCluster : undefined,
        'IncludeKpiPoints':  options ? options.includeKpiPoints : undefined,
        'IncludeKpiPercentages':  options ? options.includeKpiPercentages : undefined,
        'IncludeKpiQuestions':  options ? options.includeKpiQuestions : undefined,
        'KpiIds': (filter && _.size(filter.kpiIds) > 0) ? filter.kpiIds.join() : undefined,
        'IncludeCustomProperties':  options ? options.includeCustomProperties : undefined,
        'IncludeQuestionsWithoutAnswers':  options ? options.includeQuestionsWithoutAnswers : undefined,
        'IncludeTestchecks': filter ? filter.includeTestchecks : undefined,
        'IncludeLocationInfo': options ? options.includeLocationInfo : undefined,
        'IncludeOverallScore': options ? options.includeOverallScore : undefined,
        'IncludeOverallPoints': options ? options.includeOverallPoints : undefined,
        'SortOrder': options ? options.sortOrder : undefined,
        'LocalizationId': (options && options.localizationId) ? options.localizationId : i18n.global.locale,
      },
      {
        baseURL: this.baseURL,
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      });
  },

  getFrequencies(filter, options, cancelToken) {
    return axios.post('get-frequencies', {
        'SurveyIds': (filter && _.size(filter.surveyIds) > 0) ? filter.surveyIds.join() : undefined,
        'WaveIds': (filter && _.size(filter.waveIds) > 0) ? filter.waveIds.join() : undefined,
        'ScenarioIds': (filter && _.size(filter.scenarioIds) > 0) ? filter.scenarioIds.join() : undefined,
        'DatePeriods': (filter && _.size(filter.datePeriods) > 0) ? filter.datePeriods.join() : null,
        "DateFrom": filter?.dateFrom ? dayjs(filter?.dateFrom).format('YYYY-MM-DD') : null,
        "DateTo": filter?.dateTo ? dayjs(filter?.dateTo).format('YYYY-MM-DD') : null,
        'ClientLocationIds': (filter && _.size(filter.locationIds) > 0) ? filter.locationIds.join() : undefined,
        'CustomPropertyValueIds': (filter && _.size(filter.propertyIds) > 0) ? filter.propertyIds.join('|') : undefined,
        'CustomPropertyUseLogicalAnd': filter ? filter.customPropertyUseLogicalAnd : undefined,
        'AggregationLevel': options ? options.aggregationLevel : null,
        'AggregationLevel2': options ? options.aggregationLevel2 : null,
        'SurveyInstanceStatusIdMinimum': filter ? filter.surveyInstanceStatusIdMinimum : undefined,
        'SurveyInstanceStatusIdMaximum': filter ? filter.surveyInstanceStatusIdMaximum : undefined,
        'IncludeTestchecks': filter ? filter.includeTestchecks : undefined,
        'UseCompactLayout':  options ? options.useCompactLayout : null,
        'LocalizationId': (options && options.localizationId) ? options.localizationId : i18n.global.locale,
      },
      {
        baseURL: this.baseURL,
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      });
  },

  getBonusReport(filter, cancelToken) {
    return axios.post('get-bonus-report', {
        'SurveyId': (filter && _.size(filter.surveyIds) > 0) ? filter.surveyIds[0] : undefined,
        'WaveIds': (filter && _.size(filter.waveIds) > 0) ? filter.waveIds.join() : undefined,
        'ScenarioIds': (filter && _.size(filter.scenarioIds) > 0) ? filter.scenarioIds.join() : undefined,
        'ClientLocationIds': (filter && _.size(filter.clientLocationIds) > 0) ? filter.clientLocationIds.join() : undefined,
        'CustomPropertyValueIds': (filter && _.size(filter.propertyIds) > 0) ? filter.propertyIds.join('|') : undefined,
        'LocalizationId': i18n.global.locale,
      },
      {
        baseURL: this.baseURL,
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      });
  },

  getCheckRevisionExport(filter, options, cancelToken) {
    return axios.post('get-check-revision-export', {
        'SurveyIds': (filter && _.size(filter.surveyIds) > 0) ? filter.surveyIds.join() : undefined,
        'WaveIds': (filter && _.size(filter.waveIds) > 0) ? filter.waveIds.join() : undefined,
        'ScenarioIds': (filter && _.size(filter.scenarioIds) > 0) ? filter.scenarioIds.join() : undefined,
        'ClientLocationIds': (filter && _.size(filter.clientLocationIds) > 0) ? filter.clientLocationIds.join() : undefined,
        'PropertyIds': (filter && _.size(filter.propertyIds) > 0) ? filter.propertyIds.join('|') : undefined,
        'PropertyIdsUseLogicalAnd': filter ? filter.propertyUseLogicalAnd : undefined,
        'SearchText': filter ? filter.searchText : undefined,
        'SurveyInstanceStatusIdMinimum': filter ? filter.surveyInstanceStatusIdMinimum : undefined,
        'SurveyInstanceStatusIdMaximum': filter ? filter.surveyInstanceStatusIdMaximum : undefined,
        'IncludeCustomProperties':  options ? options.includeCustomProperties : undefined,
        'IncludeTestchecks': filter ? filter.includeTestchecks : undefined,
        'IncludeLocationInfo': filter ? filter.includeLocationInfo : undefined,
        'IncludeOverallScore': options ? options.includeOverallScore : undefined,
        'IncludeOverallPoints': options ? options.includeOverallPoints : undefined,
        'LocalizationId': (options && options.localizationId) ? options.localizationId : i18n.global.locale,
      },
      {
        baseURL: this.baseURL,
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      });
  },
};
